import classnames from "classnames";

export default function WarningText({ text, className }) {
  return (
    <p className={classnames("text-orange-500 text-sm", className)}>{text}</p>
  );
}
